module.exports = __webpack_public_path__ + "img/CapeTipEstates_1.09052c1e.png";